import {authorizeEndpoint} from './components/consts'

export const redirectToAuthorize = (encodedQueryString) => {
  window.location.replace(`${window.location.origin}${authorizeEndpoint}${encodedQueryString ?? ''}`)
}
